import React from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { setImgSrcSize, resizeHandler } from '../../utils';
import HCarouselHolder from './HCarouselStyles';

class HCarousel extends React.Component {
	state = {imgToRotate: [], index: 0, selected: {}};

	componentDidMount() {
		const imgIntervalTime = this.props.fadeOutTiming;
		const itemsToRotate = this.props.items.filter((item,i)=>{
			if(i > 2) {
				return item;
			}
		});

		this.setState({imgToRotate: itemsToRotate});
		this.setState({selected: this.props.items[3]});

		setInterval(()=> {
			this.showNext()
		},imgIntervalTime);

		resizeHandler('.carousel-img');

		window.addEventListener('resize', debounce(function() {
			resizeHandler('.carousel-img');
		},300));

	}

	componentWillUnmount() {
		window.removeEventListener('resize',()=>resizeHandler('.carousel-img'));
	}

	componentDidUpdate(prevProps) {
		if (prevProps.current_lang !== this.props.current_lang) {
			setTimeout(()=>{
				const itemsToRotate = this.props.items.filter((item,i)=>{
					if(i > 2) {
						return item;
					}
				});
		
				this.setState({imgToRotate: itemsToRotate});
				this.setState({selected: this.props.items[3]});
			},1000);
		}
	}

	showNext = () => {
		this.setState(prevState => {
			const newIndex = prevState.index < this.state.imgToRotate.length - 1 ? prevState.index + 1 : 0;
			return {
			  index: newIndex,
			  selected: this.state.imgToRotate[newIndex]
			};
		});
	}


	renderItems = () =>{
		return this.props.items.map((item,i)=> {
			if(i < 3) {
				return (
					<a key={i} href={item.url} target={item.openNewTab === "true" ? "_blank" : "_self"} className="carousel-img" itemProp='itemListElement'> 
						<img src={setImgSrcSize(item.image, window.innerWidth > 1050 ? "md" : "sm")} alt={item.altImageTxt ? item.altImageTxt : `carousel image ${i}`} itemProp='image'/>
					</a>
				)
			}
		})
	}

	render () {
		return (
			<HCarouselHolder itemScope itemType='https://schema.org/ItemList'>
				{this.renderItems()}
				<ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={5000} transitionLeaveTimeout={3000} transitionAppear={true} transitionAppearTimeout={1000}>
					{this.state.selected && 
						<a className="carousel-img" href={this.state.selected.url} target={this.state.selected.openNewTab === "true" ? "_blank" : "_self"} itemProp='itemListElement'>
							<img src={setImgSrcSize(this.state.selected.image, window.innerWidth > 1050 ? "md" : "sm")} alt={this.state.selected.altImageTxt ? this.state.selected.altImageTxt : "carousel image selected"} itemProp='image'/>
						</a>
					}
				</ReactCSSTransitionGroup>
			</HCarouselHolder>
		)
	}
}

const mapStateToProps = (store) => ({
    current_lang: store.language.current,
});

export default connect(mapStateToProps,null)(HCarousel);